import React, { useState } from 'react'
import cx from 'classnames'
import Select from 'react-select'
import './select.scss'

export const VegaSelectBase = ({
	components,
	options,
	onChange,
	disabled = false,
	defaultValue,
	className
}) => {
	const [currentOption, setCurrentOption] = useState(defaultValue)

	const handleChange = (selectedOption) => {
		if (selectedOption?.value !== currentOption?.value) {
			setCurrentOption(selectedOption)
			if (onChange) {
				onChange(selectedOption)
			}
		}
	}

	return (
		<Select
			menuPlacement="auto"
			classNamePrefix="vega_select"
			components={components}
			options={options}
			defaultValue={currentOption}
			className={cx('vega_select__container', className)}
			isDisabled={disabled}
			onChange={handleChange}
		/>
	)
}
